module.exports = __webpack_public_path__ + "static/media/logo.9725d1b1.png";